// material-ui
import Typography from '@mui/material/Typography';

export default function Footer() {
  return (
    <Typography variant="caption" sx={{ p: '24px 16px 0px', mt: 'auto', textAlign: 'right' }}>
      © Zamuvr 2025
    </Typography>
  );
}
